import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import DeathCertificateListingContent from './DeathCertificateListingContent';
import useDebounce from '../../../../../../common/hooks/useDebounce';
import DeathCertModal from '../components/DeathCertModal';
// import UpdateModal from '../components/UpdateModal';
import ImageContainer from '../components/ImageContainer';

const INIT_FILTER = {
  q: '',
  sort_by: 'desc',
};

function DeathCertificateListingContainer({
  match,
  history,
  getDeathCertificateList,
  userManagementList,
  userManagementListPager,
  isLoading,
  removeUserManagement,
  showDeathCertificate,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getDeathCertificateList(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleModal = (data) => {
    setModal({
      isOpen: true,
      content: <DeathCertModal recordData={data} />,
      title: !data ? 'Add Death Certificate Record' : 'Update Record',
      modalSize: 'modal-xl',
    });
  };

  const handleViewImage = (data, page) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ImageContainer info={data} page={page} />,
      title: `Death Certificate - ${page}`,
      modalSize: 'modal-xl',
    });
  };

  // const handleEdit = (data) => (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <UpdateModal updateList={data.attributes} id={data.id} />,
  //     title: 'Update Record',
  //     modalSize: 'modal-xl',
  //   });
  // };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this userManagement?',
      () => {
        removeUserManagement(data.id, () => {
          getDeathCertificateList(INIT_FILTER);
          const id = _.get(userManagementList, '0.id');
          history.push(`/user-management/employees/${id}`);
          showDeathCertificate(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:userManagementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Records"
            // getData={getDeathCertificateList}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Records..."
            listName="Transaction"
            label="Records List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <span> {_.get(item, 'attributes.first_name')} </span>{' '}
                <span>{_.get(item, 'attributes.last_name')}</span>
              </div>
            )}
            isLoading={isLoading}
            selected={params.userManagementId}
            data={userManagementList}
            dataPager={userManagementListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:userManagementId?`}
                    render={() => (
                      <DeathCertificateListingContent
                        handleModal={handleModal}
                        handleRemove={handleRemove}
                        handleViewImage={handleViewImage}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:userManagementId?`}
                  render={() =>
                    !params.userManagementId &&
                    userManagementList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(userManagementList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

DeathCertificateListingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getDeathCertificateList: PropTypes.instanceOf(Function).isRequired,
  userManagementList: PropTypes.instanceOf(Array).isRequired,
  userManagementListPager: PropTypes.instanceOf(Object).isRequired,
  removeUserManagement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showDeathCertificate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  userManagementList: _.get(api, `${c.GET_DEATH_CERTIFICATE}.list`) || [],
  userManagementListPager: _.get(api, `${c.GET_DEATH_CERTIFICATE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_DEATH_CERTIFICATE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DeathCertificateListingContainer);
